import React from 'react';

function FocusLens({ isRecording }) {
  return (
    <span className={`br-draft-lens ${isRecording ? 'is-listening' : 'is-resolving'}`} aria-hidden="true">
      <span className="br-draft-lens__core" />
      <span className="br-draft-lens__arc br-draft-lens__arc--one" />
      <span className="br-draft-lens__arc br-draft-lens__arc--two" />
    </span>
  );
}

export default function VoiceDraftPanel({ isRecording, onCancel, onFinish }) {
  return (
    <div className="br-draft-overlay" role="dialog" aria-modal="true" aria-labelledby="voice-draft-title">
      <button type="button" className="br-draft-overlay__scrim" onClick={onCancel} aria-label="Cancel transcription" />
      <div className="br-draft-panel br-glass">
        <button type="button" onClick={onCancel} aria-label="Cancel transcription" className="br-draft-action">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" /></svg>
        </button>

        <div className="br-draft-status">
          <FocusLens isRecording={isRecording} />
          <div>
            <p className="br-draft-status__eyebrow">Voice to text</p>
            <h2 id="voice-draft-title">{isRecording ? 'Listening with you' : 'Composing your words'}</h2>
          </div>
        </div>

        <button type="button" onClick={onFinish} aria-label="Finish transcription" className="br-draft-action br-draft-action--confirm">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
        </button>
      </div>
    </div>
  );
}
